import useOrderApi from "../../api/OrderApi";
import useShapeApi from "../../api/ShapeApi";
import OrderItemCleanupDialog, { CompletedOrderItem, OrderedItem, OrderedKitItem } from "../cleanup/OrderItemCleanupDialog";

interface Props {
  readonly customerId: number;
  readonly priceListId: number;
  open: boolean;
  onCleanupConfirmed: (messages: string[]) => void;
  onCleanupCanceled: () => void;
}

const ShapesCleanupDialog = (props: Props) => {
  const shapeApi = useShapeApi();
  const orderApi = useOrderApi();
  const customerId = props.customerId;
  const priceListId = props.priceListId;

  const fetchCompletedOrderItems = (customerId: number) : Promise<CompletedOrderItem[]> =>
    shapeApi
      .fetchCompletedOrderShapes(customerId)
      .then(orderShapes => orderShapes
        .map(completedOrderShape => ({
          itemId: completedOrderShape.shapeId,
          name: completedOrderShape.name,
          latestCompletionDate: completedOrderShape.latestCompletionDate
      })));

  const fetchActiveOrderedItems = (customerId: number) : Promise<OrderedItem[]> =>
    orderApi
      .fetchActiveOrderedShapes(customerId)
      .then(orderedShapes => orderedShapes
        .map(orderedShape => ({
          item: orderedShape.shape
      })));

  const fetchActiveOrderedKitItems = (customerId: number) : Promise<OrderedKitItem[]> =>
    orderApi
      .fetchOrderedKitShapes(customerId)
      .then(orderedKitShapes => orderedKitShapes
        .map(orderedKitShape => ({
          item: orderedKitShape.shape,
          kit: orderedKitShape.kit,
          order: orderedKitShape.order
      })));

  return <OrderItemCleanupDialog
    customerId={ customerId }
    open={ props.open }
    onCleanupConfirmed={ props.onCleanupConfirmed }
    onCleanupCanceled={ props.onCleanupCanceled }
    fetchItems={ customerId => shapeApi.fetchShapes(customerId, priceListId) }
    fetchCompletedOrderItems={ fetchCompletedOrderItems }
    fetchActiveOrderedItems={ fetchActiveOrderedItems }
    fetchActiveOrderedKitItems={ fetchActiveOrderedKitItems }
    deleteItem={ (customerId, shapeId) => shapeApi.deleteShape(customerId, priceListId, shapeId) }
    messages={({
      itemDeletedSuccessfully: 'Usunięto wykrój',
      failedToDeleteItem: 'Napotkano PROBLEM podczas usuwania wykroju',
      used: 'wykorzystywany'
    })}
  />;
}

export default ShapesCleanupDialog;